export default "__VITE_ASSET__pXrcjKup__"